var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    opacity: _vm.visible ? '1' : '0',
    'pointer-events': _vm.visible ? 'auto' : 'none',
  }),attrs:{"id":"bi-loading-modal"}},[_c('div',{staticClass:"bi-loading-modal-backdrop"},[_c('div',{staticClass:"bi-loading-modal-content"},[_c('b-spinner',{class:_vm.spinnerClass,style:({
          width: _vm._size,
          height: _vm._size,
        }),attrs:{"variant":"white"}}),_vm._v(" "),_c(_vm.labelTag,{tag:"component",class:(_vm.labelClass + " text-white")},[_vm._v(_vm._s(_vm.label))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }